import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import {FiCheck,FiArrowRight,FiStar,FiShield,FiSettings,FiGlobe,FiTarget,FiZap,FiTrendingUp,FiLayers,FiMapPin,FiClock,FiSearch,FiBarChart2} from 'react-icons/fi';
import CTAButton from '../components/CTAButton';
import MetricsStrip from '../components/MetricsStrip';
import CaseStudyProofBlock from '../components/CaseStudyProofBlock';
import {BUSINESS,SERVICES,TRUST_SIGNALS} from '../config/business';
import {reviews} from '../data/proofData';
import {caseStudies} from '../data/caseStudies';
import {publishedProducts} from '../data/productsData';
import SEO from '../components/SEO';
import AutoScrollCarousel from '../components/AutoScrollCarousel';
function Home() {
const trustPoints=[
 {icon: FiGlobe,text: TRUST_SIGNALS[0]},{icon: FiSettings,text: TRUST_SIGNALS[3]},{icon: FiShield,text: TRUST_SIGNALS[4]}
 ];
const serviceAreas=[
 'Sydney CBD','Surry Hills','Parramatta','North Sydney','Northern Beaches','Eastern Suburbs','Western Sydney','Melbourne','Brisbane','Australia-wide'
 ];
const renderReviewCard=(review)=> (
 <div className="bg-white p-6 sm:p-8 rounded-2xl border border-slate-100 shadow-sm h-full flex flex-col text-center">
  <div className="flex justify-center mb-4">
   {[...Array(5)].map((_,i)=> (
    <SafeIcon key={i} icon={FiStar} className={`h-4 w-4 ${i < review.rating ? 'text-yellow-400 fill-yellow-400' : 'text-slate-200'}`} />
   ))}
  </div>
  <p className="text-sm sm:text-base text-slate-700 italic mb-8 leading-relaxed flex-grow">"{review.text}"</p>
  <div className="mt-auto">
   <div className="font-bold text-slate-900 text-sm sm:text-base">{review.name}</div>
   <div className="text-[11px] sm:text-xs text-slate-500 mb-3 font-medium uppercase tracking-wider">
    {review.industry} {review.suburb && <span>&bull;{review.suburb}</span>}
   </div>
   <div className="inline-block px-3 py-1 bg-green-50 text-green-700 text-[10px] sm:text-xs font-bold rounded-full border border-green-100">
    {review.outcome}
   </div>
  </div>
 </div>
);
const calcUrl="https://app.bpasolutions.au/hidden-cost-calculator?utm_source=bpasolutions_website&utm_medium=homepage_assessment_tools&utm_campaign=manual_process_cost_calculator&utm_content=assessment_tools";
const quizUrl="https://go.meiro.cc/1233235?utm_source=bpasolutions_website&utm_medium=homepage_assessment_tools&utm_campaign=website_modernisation_quiz&utm_content=assessment_tools";
const featuredProduct=publishedProducts.find(product => product.featured && product.status === "live");
return (
 <main className="overflow-x-hidden text-left">
  <SEO title="Business Process Automation & AI Solutions Australia | BPA Solutions" description="Business automation Sydney experts helping small businesses streamline operations with AI automation and custom systems. Registered business based in Sydney,Australia." />
  {/* Hero Section */}
  <section className="relative bg-gradient-to-br from-slate-50 to-blue-50 py-16 lg:py-24">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
     <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6}}>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-slate-900 mb-6 leading-[1.15]">
       Business Process Automation & AI Solutions for{' '}
       <span className="text-blue-600 block sm:inline">Australian Small Businesses</span>
      </h1>
      <p className="text-lg sm:text-xl text-slate-600 mb-10 leading-relaxed max-w-2xl">
       We build automated systems and high-converting business websites so you can grow without burning out. Sydney-based and serving clients all over Australia.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
       <CTAButton size="lg" className="w-full sm:w-auto px-10">
        Book a Free Consult
       </CTAButton>
       <Link to="/services" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-lg border-2 border-slate-300 text-slate-700 hover:border-blue-600 hover:text-blue-600 transition-all duration-300 w-full sm:w-auto bg-white/50 backdrop-blur-sm">
        View Services
        <SafeIcon icon={FiArrowRight} className="ml-2 h-5 w-5" />
       </Link>
      </div>
     </motion.div>
     <div className="relative hidden lg:block">
      <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1000&h=500&fit=crop" alt="Business automation team" className="rounded-2xl shadow-2xl border-4 border-white" width="1000" height="500" />
     </div>
    </div>
   </div>
  </section>
  {/* Entity / Trust Statement */}
  <section className="py-10 bg-white border-b border-slate-100">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="bg-slate-50 rounded-2xl border border-slate-200 px-6 py-6 sm:px-10 sm:py-8">
     <div className="flex flex-col md:flex-row md:items-start gap-6">
      <div className="shrink-0">
       <div className="bg-blue-600 p-3 rounded-xl w-fit">
        <SafeIcon icon={FiShield} className="h-6 w-6 text-white" />
       </div>
      </div>
      <div>
       <p className="text-sm sm:text-base text-slate-700 leading-relaxed mb-4">
        BPA Solutions is a registered business based in Sydney,Australia,providing website design,web application development,business automation,CRM automation,reporting dashboards,and workflow systems for small businesses,trades,construction,service businesses,and professional services across Australia.
       </p>
       <div className="flex flex-wrap gap-x-6 gap-y-2">
        {[
         'Sydney-based,servicing businesses across Australia','Website design and custom web applications','Business automation,CRM,dashboards,and integrations','Built for small business,trades,construction,and service businesses'
        ].map((point,i)=> (
         <div key={i} className="flex items-center gap-2 text-xs sm:text-sm text-slate-600 font-medium">
          <SafeIcon icon={FiCheck} className="h-4 w-4 text-blue-500 shrink-0" />
          {point}
         </div>
        ))}
       </div>
      </div>
     </div>
    </div>
   </div>
  </section>
  {/* Trust Bar */}
  <section className="py-12 bg-white border-b border-slate-100">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
     {trustPoints.map((point,index)=> (
      <div key={index} className="flex items-center space-x-4 p-5 bg-slate-50 rounded-2xl border border-slate-100">
       <div className="bg-blue-600 p-2.5 rounded-xl">
        <SafeIcon icon={point.icon} className="h-5 w-5 text-white" />
       </div>
       <p className="text-sm sm:text-base font-bold text-slate-900">{point.text}</p>
      </div>
     ))}
    </div>
   </div>
  </section>
  <MetricsStrip />
  {/* Problems We Solve Section */}
  <section className="py-16 sm:py-24 bg-white">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
     <div>
      <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-6">
       Common Bottlenecks in Australian Service Businesses
      </h2>
      <p className="text-slate-600 mb-6 leading-relaxed">
       Most Australian small business owners started their journey for freedom,but many find themselves trapped in a cycle of manual admin. When you are spending 10 to 15 hours a week just managing emails,quotes,and invoices,you are not working on your business - you are working for your admin. This "admin tax" is the silent killer of growth for local trades and professional services.
      </p>
      <p className="text-slate-600 mb-8 leading-relaxed">
       Disconnected systems are often to blame. When your website does not talk to your CRM,and your CRM does not talk to your accounting software like Xero or MYOB,data has to be moved manually. This leads to lead leakage,human error,and a massive waste of billable hours. BPA Solutions provides the bridge between these systems.
      </p>
      <div className="space-y-4">
       {[
        'Manual data entry across disconnected spreadsheets','Leads falling through the cracks due to slow response times','Inconsistent follow-ups on quotes and invoices','Lack of real-time visibility into profit and pipeline','Over-reliance on the owner for every small operational decision'
       ].map((item,i)=> (
        <div key={i} className="flex items-start gap-3">
         <SafeIcon icon={FiZap} className="h-5 w-5 text-blue-600 mt-1 shrink-0" />
         <span className="text-slate-700 font-medium">{item}</span>
        </div>
       ))}
      </div>
     </div>
     <div className="bg-slate-50 p-8 sm:p-12 rounded-3xl border border-slate-200">
      <h3 className="text-xl font-bold text-slate-900 mb-6">The BPA Solutions Approach</h3>
      <p className="text-slate-600 mb-6 leading-relaxed">
       We do not just sell software;we build systems that solve these specific Australian business challenges. Our approach combines <strong>business automation + website design</strong> to create a seamless journey from the moment a lead finds you to the moment you get paid.
      </p>
      <p className="text-slate-600 mb-6">
       As a registered,Sydney-based business,we understand the local market and the tools that Australian tradies and service providers use every day,like Xero,ServiceM8,and Cliniko. We ensure your data flows smoothly between these platforms without manual intervention.
      </p>
      <CTAButton className="w-full">Start Your Transformation</CTAButton>
     </div>
    </div>
   </div>
  </section>
  {/* Services Section */}
  <section className="py-16 sm:py-24 bg-slate-50">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-16">
     <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-slate-900 mb-6">
      Business Automation & Web Design Services
     </h2>
     <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto px-4 leading-relaxed">
      Choose a service below to see how we help you reclaim your time. We build automation systems that remove admin chaos and lead-generating websites that work 24/7.
     </p>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-16">
     {SERVICES.map((service)=> (
      <Link key={service.id} to={`/services/${service.slug}`} className="group bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-8 hover:shadow-xl transition-all duration-300 flex flex-col h-full" >
       <div className="mb-6">
        <h3 className="text-lg font-bold text-slate-900 mb-4 group-hover:text-blue-600 transition-colors leading-tight">
         {service.name}
        </h3>
        <p className="text-sm text-slate-600 mb-6 line-clamp-3 leading-relaxed">{service.description}</p>
       </div>
       <div className="mt-auto pt-6 border-t border-slate-50 flex justify-between items-center">
        <div className="text-[10px] font-extrabold text-blue-600 uppercase tracking-widest bg-blue-50 px-3 py-1.5 rounded-lg border border-blue-100">
         From {service.startingPrice}
        </div>
        <SafeIcon icon={FiArrowRight} className="text-slate-300 group-hover:text-blue-600 h-6 w-6 transform group-hover:translate-x-1 transition-all" />
       </div>
      </Link>
     ))}
    </div>
   </div>
  </section>
  {/* Featured BPA Solutions Product */}
  {featuredProduct && (
   <section className="border-t border-slate-200 bg-gradient-to-br from-blue-50 via-white to-slate-50 py-16 sm:py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
     <div className="mb-9 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
      <div className="max-w-2xl">
       <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.2em] text-blue-600">BPA Solutions software</p>
       <h2 className="text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">Discover our business applications</h2>
       <p className="mt-4 text-base leading-relaxed text-slate-600">Purpose-built software to help reduce manual work and make everyday business tasks simpler.</p>
      </div>
      <Link to="/products" className="inline-flex items-center gap-2 text-sm font-bold text-blue-700 hover:text-blue-800">Explore all products <SafeIcon icon={FiArrowRight} aria-hidden="true" /></Link>
     </div>
     <div className="grid grid-cols-1 items-center gap-8 overflow-hidden rounded-3xl border border-slate-200 bg-white p-6 shadow-lg shadow-slate-900/5 sm:p-8 lg:grid-cols-2 lg:p-10">
      <div>
       <span className="inline-flex rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700">Available now</span>
       <h3 className="mt-5 text-3xl font-extrabold text-slate-900">{featuredProduct.name}</h3>
       <p className="mt-3 text-lg font-semibold text-slate-800">{featuredProduct.tagline}</p>
       <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600">{featuredProduct.description}</p>
       <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link to="/products" className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-6 py-3 text-sm font-bold text-blue-700 hover:bg-blue-100">View product details <SafeIcon icon={FiArrowRight} aria-hidden="true" /></Link>
        {featuredProduct.landingPageUrl && (
         <a href={featuredProduct.landingPageUrl} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-blue-600 px-6 py-3 text-sm font-bold text-white hover:bg-blue-700">Visit product website <SafeIcon icon={FiArrowRight} aria-hidden="true" /></a>
        )}
       </div>
      </div>
      <div className="flex min-h-60 items-center justify-center overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 p-5 sm:min-h-72">
       {featuredProduct.images?.[0] ? (
        <img src={featuredProduct.images[0].url} alt={featuredProduct.images[0].alt} loading="lazy" decoding="async" className="max-h-72 w-full object-contain" />
       ) : (
        <span className="text-xl font-bold text-blue-600">{featuredProduct.name}</span>
       )}
      </div>
     </div>
    </div>
   </section>
  )}
  {/* Case Studies Proof Blocks */}
  <section className="py-16 sm:py-24 bg-white border-t border-slate-200">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-16">
     <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-6 tracking-tight">
      How We Help Australian Businesses Scale
     </h2>
     <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto px-4 leading-relaxed">
      Real problems solved for service businesses,trades,and professional services across Australia.
     </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
     {caseStudies.map((caseStudy)=> (
      <CaseStudyProofBlock key={caseStudy.id} caseStudy={caseStudy} />
     ))}
    </div>
   </div>
  </section>
  {/* Who This Is For Section */}
  <section className="py-16 sm:py-24 bg-white">
   <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-8">Who We Help Scale</h2>
    <p className="text-slate-600 mb-10 leading-relaxed max-w-2xl mx-auto">
     Our automation solutions are designed for established Australian small businesses that are ready to professionalize their operations and grow without increasing their administrative headcount.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 text-left">
     <div className="space-y-4">
      <h3 className="font-bold text-blue-600 flex items-center gap-2">
       <SafeIcon icon={FiTarget} /> Trades and Field Services
      </h3>
      <p className="text-sm text-slate-600 leading-relaxed">
       For electricians,plumbers,builders,and landscapers who are tired of manual quoting and scheduling. We implement field-service automation that links your site work to your office admin seamlessly,ensuring that site photos and notes are never lost.
      </p>
     </div>
     <div className="space-y-4">
      <h3 className="font-bold text-blue-600 flex items-center gap-2">
       <SafeIcon icon={FiTrendingUp} /> Professional Services
      </h3>
      <p className="text-sm text-slate-600 leading-relaxed">
       For NDIS providers,medical clinics,and consultants who need robust compliance tracking and automated patient or client management systems to handle growth without administrative overhead.
      </p>
     </div>
    </div>
   </div>
  </section>
  {/* Service Area Section */}
  <section className="py-14 bg-slate-50 border-t border-slate-200">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-8">
     <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3">
      Website design and automation services across Sydney and Australia
     </h2>
     <p className="text-sm sm:text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
      BPA Solutions is based in Sydney and works with businesses across Australia,including professional services,trades,construction,consulting,property,healthcare,and local service businesses.
     </p>
    </div>
    <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
     {serviceAreas.map((area)=> (
      <span key={area} className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-full text-xs sm:text-sm font-medium text-slate-600 shadow-sm">
       <SafeIcon icon={FiMapPin} className="h-3 w-3 text-blue-500 shrink-0" />
       {area}
      </span>
     ))}
    </div>
   </div>
  </section>
  {/* Reviews Section */}
  <section className="py-16 sm:py-24 bg-white overflow-hidden">
   <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-12">
     <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 mb-4 tracking-tight">
      Reviews from Australian SMB Owners
     </h2>
     <p className="text-slate-600 font-medium">
      Real feedback from local businesses reclaiming their time via automation for small business.
     </p>
    </div>
    <AutoScrollCarousel items={reviews} renderItem={renderReviewCard} className="w-full" />
   </div>
  </section>
  {/* Free Business Assessment Tools */}
  <section className="py-16 sm:py-24 bg-slate-50 border-t border-slate-200">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4 tracking-tight">Free Business Assessment Tools</h2>
    <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto px-4 mb-12 leading-relaxed">
     Use these practical tools to understand where time, enquiries and business efficiency may be slipping away.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 text-left">
     {/* Card 1: Calculator */}
     <div className="bg-white p-6 rounded-2xl border-2 border-blue-200 shadow-sm flex flex-col relative">
      <div className="absolute top-4 right-4">
       <span className="text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md bg-blue-600 text-white">MOST POPULAR</span>
      </div>
      <div className="bg-blue-50 p-3 rounded-xl w-fit mb-4">
       <SafeIcon icon={FiClock} className="h-6 w-6 text-blue-600" />
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-3 pr-20">Manual Process Cost Calculator</h3>
      <p className="text-sm text-slate-600 mb-6 flex-grow">Estimate what repetitive administration, disconnected spreadsheets, errors and rework may be costing your business each year.</p>
      <a href={calcUrl} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center justify-center px-6 py-3 text-base font-bold rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all shadow-sm active:scale-[0.98]">
       Calculate My Hidden Cost
      </a>
     </div>
     {/* Card 2: Quiz */}
     <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex flex-col">
      <div className="bg-blue-50 p-3 rounded-xl w-fit mb-4">
       <SafeIcon icon={FiSearch} className="h-6 w-6 text-blue-600" />
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-3">Website Modernisation Quiz</h3>
      <p className="text-sm text-slate-600 mb-6 flex-grow">See whether your current website is helping or hurting enquiries, mobile experience, trust and conversion opportunities.</p>
      <a href={quizUrl} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center justify-center px-6 py-3 text-base font-bold rounded-lg bg-slate-100 text-slate-700 hover:bg-slate-200 transition-all border border-slate-200">
       Start the Quiz
      </a>
     </div>
     {/* Card 3: Readiness */}
     <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex flex-col opacity-80 relative md:col-span-2 md:max-w-xl md:w-full md:mx-auto lg:col-span-1 lg:max-w-none">
      <div className="absolute top-4 right-4">
       <span className="text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md bg-slate-200 text-slate-700">COMING SOON</span>
      </div>
      <div className="bg-slate-100 p-3 rounded-xl w-fit mb-4">
       <SafeIcon icon={FiBarChart2} className="h-6 w-6 text-slate-500" />
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-3 pr-20">Automation Readiness Assessment</h3>
      <p className="text-sm text-slate-600 mb-6 flex-grow">Identify where practical automation could have the greatest impact across your business operations.</p>
      <button disabled aria-disabled="true" className="mt-auto inline-flex items-center justify-center px-6 py-3 text-base font-bold rounded-lg bg-slate-100 text-slate-400 cursor-not-allowed border border-slate-200">
       Coming Soon
      </button>
     </div>
    </div>
   </div>
  </section>
  {/* Internal Linking Section */}
  <section className="py-16 bg-slate-900 text-white">
   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h2 className="text-2xl font-bold mb-4">Explore More Automation Resources</h2>
    <p className="text-slate-400 mb-10">Practical advice and tools for Australian business owners looking to scale.</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
     {[
      {label: 'Our Services',href: '/services',icon: FiLayers},{label: 'About BPA Solutions',href: '/about',icon: FiGlobe},{label: 'Automation Blog',href: '/blog',icon: FiZap},{label: 'Free Tools',href: '/resources',icon: FiCheck}
     ].map((link,i)=> (
      <Link key={i} to={link.href} className="flex items-center justify-between p-6 bg-slate-800 rounded-xl hover:bg-slate-700 transition-colors border border-slate-700 group" >
       <span className="font-bold">{link.label}</span>
       <SafeIcon icon={link.icon} className="text-blue-400 group-hover:scale-110 transition-transform" />
      </Link>
     ))}
    </div>
   </div>
  </section>
 </main>
);
}
export default Home;